const console_log = log => {
  if (process.env.REACT_APP_debug_log) {
    const stack = new Error().stack
    const callerLine = stack.split('\n')[2] // This is the caller line
    const match = callerLine.match(/\((.*):(\d+):\d+\)/) // Extract file and line number

    if (match) {
      const [, file, line] = match
      console.log(`[${file}:${line}]`, log)
    } else {
      console.log(log)
    }
  }
}

export default console_log
